import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { get } from 'lodash';

import CopyIcon from '~/assets/svgs/copy.svg';
import CopyIconSuccess from '~/assets/svgs/tick.svg';
import Tooltip from '~/components/Tooltip';
import TooltipTwo from '~/components/TooltipTwo';

type StepReviewThanksProps = {
    form?: any;
    onSlickNext?: any;
    discountCode?: string;
};

const StepReviewThanks = ({ form, onSlickNext, discountCode }: StepReviewThanksProps) => {
    const files = get(form, `values.files`);
    const [isCopy, setCopy] = useState(false);

    const handleCopy = (e: any) => {
        navigator.clipboard.writeText(discountCode as string);
        setCopy(true);
    };

    useEffect(() => {
        if (isCopy) {
            const timeout = setTimeout(() => {
                setCopy(false);
                clearTimeout(timeout);
            }, 3000);
        }
    }, [isCopy]);
    if (!discountCode) {
        return (
            <div className="flex flex-col items-center justify-center gap-4">
                <h2 className="text-center text-5xl font-bold">Thank you!</h2>
                <p className="text-center">Your review has been submitted.</p>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center gap-4">
            <h2 className="text-center text-5xl font-bold">Thank you!</h2>
            <div>
                {!!files?.length ? (
                    <div className={classNames('flex  items-start hover:cursor-pointer')} onClick={handleCopy}>
                        <div>{discountCode}</div>
                        <TooltipTwo id="copy" title={<div className="text-nowrap">{isCopy ? 'Copied to clipboard' : 'Click to copy'}</div>}>
                            <div className="relative w-6 h-6">
                                <div
                                    // title="Copied to clipboard"
                                    className={`absolute right-0 top-0 transition-all duration-300${isCopy ? 'translate-y-0 opacity-100' : 'translate-y-1 opacity-0'
                                        }`}
                                >
                                    <CopyIconSuccess className="text-green-500" width={24} height={24} />
                                </div>

                                <div
                                    // title="Copy"
                                    className={`absolute top-0 right-0  transition-all duration-300 transform ${!isCopy ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-1'
                                        }`}
                                >
                                    <CopyIcon width={24} height={24} className="text-black" />
                                </div>
                            </div>
                        </TooltipTwo>
                    </div>
                ) : (
                    <p className="text-center">Your review has been submitted.</p>
                )}
            </div>
        </div>
    );
};

export default StepReviewThanks;
